import React from "react";
import { getValue } from "@utils/lodash";

function RedoSvgComponent(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <defs>
        <clipPath id="clip-path-redo">
          <rect id="Rectangle_18167" data-name="Rectangle 18167" width="24" height="24" transform="translate(-10471 -7160)" fill="#fff"/>
        </clipPath>
      </defs>
      <g id="Mask_Group_275" data-name="Mask Group 275" transform="translate(10471 7160)" clip-path="url(#clip-path-redo)">
        <path id="prompt_suggestion_FILL0_wght300_GRAD0_opsz24" d="M17.087-12.118l-1.116-1.141L19.9-17.212H9.35a4.239,4.239,0,0,1-3.12-1.294,4.308,4.308,0,0,1-1.288-3.158,4.308,4.308,0,0,1,1.288-3.158,4.239,4.239,0,0,1,3.12-1.294h.509V-24.5H9.35a2.721,2.721,0,0,0-2,.822,2.738,2.738,0,0,0-.824,2.015,2.738,2.738,0,0,0,.824,2.015,2.721,2.721,0,0,0,2,.822H19.9l-3.928-3.98,1.116-1.125,5.854,5.913Z" transform="translate(-10472.941 -7128.882)" fill="#dadce0"/>
      </g>
    </svg>

  );
}

export default RedoSvgComponent;
